// extracted by mini-css-extract-plugin
module.exports = {"protalPage":"portal_protalPage__eXkIo","buttons":"portal_buttons__3EdPA","btn":"portal_btn__2bijb"};